import React from 'react';
import PropTypes from 'prop-types';


import * as billingConstants from '../billingConstants';

import {Address} from '../../Address';
import {I18nMessage} from '../../I18n';

import styles from './BillingData.scss';


function BillingData({billingData}) {

    const {address, taxNumber} = billingData;

    return (
        <div className={styles.billingData}>

            <h3>
                <I18nMessage id={'billing.data.recipient'}/>
            </h3>

            <Address address={address}/>

            <p className={styles.taxNumber}>
                <I18nMessage id={'billing.data.taxNumber'}/>: {taxNumber || <I18nMessage id={'global.na'}/>}
            </p>

        </div>
    );
}


BillingData.propTypes = {
    billingData: PropTypes.shape(billingConstants.SHAPE_BILLING_DATA)
};

BillingData.defaultProps = {};


export default BillingData;
